import { graphql, useStaticQuery } from 'gatsby';

const DATE_OPTIONS: Intl.DateTimeFormatOptions = {
  timeZone: 'America/Toronto',
  year: 'numeric',
  month: 'long',
  day: 'numeric',
};

interface BuildDateQuery {
  buildDate: { date: string };
}

// Date the site was last built, e.g. "October 9, 2026"
const useBuildDate = () => {
  const data = useStaticQuery<BuildDateQuery>(graphql`
    query {
      buildDate {
        date
      }
    }
  `);

  return new Date(data.buildDate.date).toLocaleDateString('en-US', DATE_OPTIONS);
};

export default useBuildDate;
